import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_RISK_COMMENT_MUTATION = gql`
  mutation addOrUpdateRiskComment($input: RiskCommentInput!) {
    addOrUpdateRiskComment(input: $input) {
      correlationId
    }
  }
`;

export const DELETE_RISK_COMMENT_MUTATION = gql`
  mutation deleteRiskComment($input: DeleteRiskCommentInput!) {
    deleteRiskComment(input: $input) {
      correlationId
    }
  }
`;
